import type { TComplexStatusType } from 'types/cargo';

export const STATUS_TYPE_LABELS: Record<TComplexStatusType, string> = {
  all_in_progress: 'all in progress',
  waiting: 'waiting',
  planned: 'planned',
  warehouse: 'warehouse',
  loaded: 'loaded',
  delivered: 'delivered',
};
